import { Breadcrumbs, FinalTestView, GlossaryView, ProgressView } from '@holmescorp/mc-widgets';
import { registry } from 'lcc-state';
import { register_base_lp_widgets } from '../../shared/init/lp-init';

export function register_lp_widgets(): void {
	register_base_lp_widgets();

	registry.define('MicroBreadcrumbs', Breadcrumbs);
	registry.define('ProgressView', ProgressView);
	registry.define('FinalTestView', FinalTestView);
	registry.define('GlossaryView', GlossaryView);
}
